// @flow
import React from 'react'
import { Wrapper, Title } from './styles'

type Props = {
  active?: boolean,
  title: string
}

const Step = (props: Props) => (
  <Wrapper>
    <Title active={props.active}>{props.title}</Title>
  </Wrapper>
)

export default Step
